import React from 'react';

const NotSpammingAgency = () => {
  return (
    <div className="bg-[#F5F5F5]">
      <div className="container py-[48px]">
        <div className="flex h-full justify-center items-center flex-col gap-[24px]">
          <h2 className={'flex justify-center items-center w-full font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px]'}>
            Not Just Another Spamming Agency
          </h2>

          <p className=" text-left md:text-center leading-[20px] text-[16px] font-[400] max-w-[620px] mb-[24px]">
            Prodigi stands out as a professional SEO services agency by prioritizing quality over effective seo strategy. Check out email screenshots
            to see why quality matters in guaranteed SEO services.
          </p>

          <img className="hidden md:block" src="/images/seo/notSpam.webp" alt="notSpam" />

          <img className="block md:hidden" src="/images/seo/notSpam-mob.png" alt="notSpam" />
        </div>
      </div>
    </div>
  );
};

export default NotSpammingAgency;
